import {orderBy, sortBy} from 'lodash'
import clsx from 'clsx'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'


import {TeacherContext} from 'teacher/context'

import {isUUID} from 'helpers/utils'
import AddStandards from 'teacher/components/add-standards'
import Standard from './standard'

const useStyles = makeStyles(standardStyles)
const useAccordionStyles = makeStyles(accordionStyles)
const useAccordionDetailsStyles = makeStyles(accordionDetailsStyles)
const useAccordionSummaryStyles = makeStyles(accordionSummaryStyles)

export default function AddStandard ({onStandardsChange, question}) {

  const classes = useStyles()
  const accordionClasses = useAccordionStyles()
  const accordionDetailsClasses = useAccordionDetailsStyles()
  const accordionSummaryClasses = useAccordionSummaryStyles()
  const context = useContext(TeacherContext)

  const {translate, link, linkQuery, updateState, sectionName, operation} = context
  const {standards = []} = question.properties || {}
  const [firstStandard = {}] = standards

  const deleteStandard = (id) => {
    onStandardsChange(standards.filter(s => s.id != id))
  }

  const backPath = link({}, '/:languageId/:role/:page/:tab/:sectionName?/:questionId?')

  const standardsQuery = firstStandard.id 
    ? {subject: firstStandard.subject, grade: firstStandard.grade, standard: firstStandard.standard}
    : {subject: question.subject, grade: question.course ? question.course.substr(-3) : undefined}

  const standardLink = linkQuery(`${backPath}/add-standards`, standardsQuery)
  
  function handleOpenStandardsClick (e) {
    e.stopPropagation()
    const selected = standards.reduce((acc, standard) => ({...acc, [standard.id]: standard}), {})
    updateState({standardsContext:{selectStandards: {
      selected: {$set: selected},
    }}})
  }

  const sortedStandards = sortBy(standards, s => {
    const iteratee = `${s.expectation || s.id}-${s.code || '00'}`
    return iteratee
  })

  return (<>
      <AddStandards
        backPath={backPath}
        onSaveStandards={onStandardsChange}
        open={operation == 'add-standards'}
      />
      <Accordion
        defaultExpanded={true}
        square={true}
        classes={accordionClasses}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-label="Expand"
          aria-controls="expand-standards"
          id="expand-standards"
          classes={accordionSummaryClasses}
        >
          <span className={classes.addStandardLabel} >{translate("standards")}:</span>
          <Link className={classes.addStandard} to={standardLink} onFocus={e => e.stopPropagation()} onClick={handleOpenStandardsClick}>+</Link>
        </AccordionSummary>
        <AccordionDetails classes={accordionDetailsClasses}>
          {sortedStandards.length > 0 && (<div className={clsx(classes.wrapper, classes.content)}>{
            sortedStandards.map((standard, index) => {
              return (
                <Standard
                  index={index}
                  key={index}
                  deleteStandard={deleteStandard}
                  {...standard}
                />
              )
            })}
          </div>)}
        </AccordionDetails>
      </Accordion>
  </>
  )
}

function accordionStyles() {
  return {
    root: {
      border: 'none',
      boxShadow: 'none',
      borderBottom: 'solid 1px #e2ecf2'
    }
  }
}

function accordionSummaryStyles () {
  return {
    root: {
      padding: 0
    }
  }
}

function accordionDetailsStyles () {
  return {
    root: {
      padding: '8px 0'
    }
  }
}

function standardStyles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: 0,
    },
    item: {
      display: 'flex',
      flexDirection: 'column'
    },
    head: {
      color: '#868c9c',
      padding: '8px 20px 15px 20px',
      borderBottom: 'solid 1px #e2ecf2'
    },
    addStandardLabel: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: '#69738c',
      fontWeight: 'bold',
      flexGrow: 1,
    },
    addStandard: {
      borderRadius: 4,
      textDecoration: 'none',
      color: '#a5b9de',
      textAlign: 'center',
      fontSize: '15pt',
      backgroundColor: '#f0f7ff',
      border: 'solid 1px #a5b9de',
      padding: '4px 8px',
      "&:hover": {
        transform: 'scale(1.01)',
        fontWeight: 'bold'
      }
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      padding: '0 0 0 0',
    }
  }
}
